module.exports = __webpack_public_path__ + "static/media/certificate.8efc4b34.svg";